import {
  UPLOAD_PROFILE,
  UPLOAD_PROFILE_SUCCESS,
  UPLOAD_PROFILE_FAILURE,
} from 'store/profileUpload/profileUploadAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const UploadReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPLOAD_PROFILE:
      return { ...state, loading: true };
    case UPLOAD_PROFILE_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case UPLOAD_PROFILE_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default UploadReducer;
